import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old path of the Kindle delivery history; it now lives on the Kindle settings page. */
export const Route = createFileRoute("/_app/settings/kindle-history")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/kindle", replace: true });
  },
});
